import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import ItacaCrear from '../assets/images/itaca-crear-v4.png';
import ItacaHistorias from '../assets/images/itaca-historias-v1.png';
import ItacaHablemos from '../assets/images/itaca-hablemos-v1.png';
import {
    CarouselContainer,
    CarouselWrapper,
    CarouselCard,
    CardContent,
    CardIcon,
    CardTitle,
    CardText,
    CtaButton,
    CarouselNavigation,
    NavButton,
    CarouselIndicators,
    Indicator
} from './Carousel.styled';

const cards = [
    {
        title: 'Crea tu historia',
        link: '/create-your-story',
        content: 'Da vida a tus ideas y crea una historia única.',
        icon: ItacaCrear, // Usamos la variable importada como 'icon'
        alt: 'Avatar de Ítaca con pincel para crear historia'
    },
    {
        title: 'Historias vividas',
        link: '/lived-stories',
        content: 'Explora las historias que otros han creado.',
        icon: ItacaHistorias,
        alt: 'Avatar de Ítaca leyendo un libro'
    },
    {
        title: 'Hablemos',
        link: '/contact',
        content: 'Ponte en contacto con nosotros para cualquier consulta.',
        icon: ItacaHablemos,
        alt: 'Avatar de Ítaca con burbuja de diálogo de contacto'
    },
];

function Carousel() {
    const [activeIndex, setActiveIndex] = useState(0);

    // Auto-rotación cada 4 segundos
    useEffect(() => {
        const interval = setInterval(() => {
            setActiveIndex((current) => (current + 1) % cards.length);
        }, 4000);

        return () => clearInterval(interval);
    }, []);

    const nextSlide = () => {
        setActiveIndex((current) => (current + 1) % cards.length);
    };

    const prevSlide = () => {
        setActiveIndex((current) => (current - 1 + cards.length) % cards.length);
    };

    const goToSlide = (index) => {
        setActiveIndex(index);
    };

    return (
        <CarouselContainer>
            <CarouselWrapper>
                {cards.map((card, index) => (
                    <CarouselCard
                        key={index}
                        className={
                            index === activeIndex ? 'active' :
                                index === (activeIndex - 1 + cards.length) % cards.length ? 'prev' :
                                    index === (activeIndex + 1) % cards.length ? 'next' : 'inactive'
                        }
                    >
                        <CardContent>
                            <CardIcon>
                                <img src={card.icon} alt={card.alt} style={{ width: '100%', height: 'auto', display: 'block' }} />
                            </CardIcon>
                            <CardTitle>{card.title}</CardTitle>
                            <CardText>{card.content}</CardText>
                            <CtaButton as={Link} to={card.link}>
                                Descubrir más
                            </CtaButton>
                        </CardContent>
                    </CarouselCard>
                ))}
            </CarouselWrapper>

            <CarouselNavigation>
                <NavButton onClick={prevSlide}>
                    ‹
                </NavButton>

                <CarouselIndicators>
                    {cards.map((_, index) => (
                        <Indicator
                            key={index}
                            className={index === activeIndex ? 'active' : ''}
                            onClick={() => goToSlide(index)}
                        />
                    ))}
                </CarouselIndicators>

                <NavButton onClick={nextSlide}>
                    ›
                </NavButton>
            </CarouselNavigation>
        </CarouselContainer>
    );
}

export default Carousel;